import { render } from "./btn_component.vue?vue&type=template&id=8e0000ce"
import script from "./btn_component.vue?vue&type=script&lang=js"
export * from "./btn_component.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Users\\felipecedillo\\Documents\\GitHub\\marbel-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__